import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[countryDefault]'
})
export class CountryDefaultDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
